/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgBoldG = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M980 847h684v809q-66 38-137 64t-146 42-151 23-152 7q-189 0-343-53t-264-156-169-253-60-345q0-199 67-358t186-270 284-170 359-59q115 0 228 16t223 55v340q-104-60-220-84t-236-24q-120 0-214 40T759 583 659 753t-35 215q0 113 29 208t87 164 147 109 208 39q52 0 105-7t102-30v-314H980V847z"
    }));
export default SvgBoldG;
